import React from "react";
import { view } from "@orderofchaos/mvvm";
import {
  AppleLoginWidgetViewModel,
  type AppleLoginWidgetViewProps,
} from "./AppleLoginWidgetViewModel";
import styles from "./AppleLoginWidget.module.css";

type AppleLoginWidgetProps = AppleLoginWidgetViewProps & {
  className?: string;
  label?: string;
};

export const AppleLoginWidget: React.FC<AppleLoginWidgetProps> = view(
  AppleLoginWidgetViewModel,
)<AppleLoginWidgetProps>(({
  className = "",
  label = "Sign in with Apple",
  disabled,
  viewModel: { signIn, buttonRef },
}) => {
  return (
    <button
      ref={buttonRef}
      type="button"
      className={`${styles.root} ${className}`}
      onClick={() => void signIn()}
      disabled={disabled}
      aria-label="Войти через Apple"
    >
      {label}
    </button>
  );
});
